import React from 'react';
import styles from './ServicesPage.module.css';
import { FaChartLine, FaBrain, FaUsers, FaLightbulb, FaCogs, FaCode, FaDatabase } from 'react-icons/fa'; // Example icons
import usePageTracking from '../components/UsePageTracking';

function ServicesPage() {

  usePageTracking();

  return (
    <div className={styles.servicesPage}>
      <section className={styles.heroServices}>
        <h1>Strategic AI Solutions for Transformative Growth.</h1>
        <p>Talk2Board AI offers bespoke solutions designed to address your most complex business challenges, leveraging the power of data for actionable insights and sustained competitive advantage.</p>
      </section>

      <section className={styles.serviceCategories}>
        <div className={styles.serviceGrid}>

         <div className={styles.serviceItem}>
            <FaCode className={styles.serviceIcon} />
            <h3>Reliable Software Engineering</h3>
            <p>We build distributed, scalable, and high-quality software using agile methodologies to ensure your AI solutions are robust and maintainable.</p>
            <ul>
              <li><small>• Distributed, scalable, and quality software. </small></li>
              <li><small>• Cloud native and agnostic development. </small></li>
              <li><small>• Agile development processes.</small></li>
              <li><small>• Robust and maintainable AI solutions. </small></li>
            </ul>
          </div>

          <div className={styles.serviceItem}>
            <FaDatabase className={styles.serviceIcon} />
            <h3>Enterprise Data Strategy</h3>
            <p>We partner with leadership to define a robust data vision, architecture, and governance framework that aligns with your strategic objectives, ensuring your data assets drive sustainable competitive advantage.</p>
            <ul>
              <li><small>• Data Maturity Assessment</small></li>
              <li><small>• Data Architecture & Roadmap</small></li>
              <li><small>• Data Governance & Quality</small></li>
              <li><small>• Data Monetization Strategies</small></li>
            </ul>
          </div>

          <div className={styles.serviceItem}>
            <FaBrain className={styles.serviceIcon} />
            <h3> AI Transformation </h3>
            <p>We design and implement solutions using Large Language Models, Retrieval-Augmented Generation (RAG), and autonomous agentic workflows to solve complex, real-world problems.</p>
            <ul>
              <li><small>• Help craft actionable AI roadmaps.</small></li>
              <li><small>• Identify opportunities fine-tuned for you.</small></li>
              <li><small>• LLM, RAG, and Agentic workflows. </small></li>
              <li><small>• Sustainable AI solutions. </small></li>
            </ul>
          </div>

          <div className={styles.serviceItem}>
            <FaLightbulb className={styles.serviceIcon} />
            <h3>Advanced Predictive Modeling</h3>
            <p>Harness the power of machine learning and statistical modeling to anticipate trends, forecast demand, identify risks, and optimize decision-making across your operations.</p>
            <ul>
              <li><small>• Demand Forecasting</small></li>
              <li><small>• Churn Prediction</small></li>
              <li><small>• Fraud Detection</small></li>
              <li><small>• Risk Scoring</small></li>
            </ul>
          </div>

          <div className={styles.serviceItem}>
            <FaUsers className={styles.serviceIcon} />
            <h3>Customer Analytics & CRM Optimization</h3>
            <p>Gain a deeper understanding of your customers through segmentation, behavioral analysis, and lifetime value modeling to personalize experiences and maximize engagement.</p>
            <ul>
              <li><small>• Customer Segmentation</small></li>
              <li><small>• Lifetime Value (LTV) Modeling</small></li>
              <li><small>• Personalization Strategies</small></li>
              <li><small>• Campaign Optimization</small></li>
            </ul>
          </div>

          <div className={styles.serviceItem}>
            <FaCogs className={styles.serviceIcon} />
            <h3>Operational Efficiency </h3>
            <p>Optimize your processes, supply chain, and resource allocation by identifying inefficiencies and bottlenecks through rigorous data analysis and simulation.</p>
            <ul>
              <li><small>• Process Optimization</small></li>
              <li><small>• Resource Allocation</small></li>
              <li><small>• Performance Dashboards</small></li>
            </ul>
          </div>
        </div>
      </section>

      <section className={styles.howWeWork}>
        <h2 className="text-center">How We Work</h2>
        <div className={styles.workSteps}>
          <div className={styles.workStep}>
            <h3>Discovery & Assessment</h3>
            <p>Understanding your unique challenges, data environment, and business objectives.</p>
          </div>
          <div className={styles.workStep}>
            <h3>Solution Design</h3>
            <p>Crafting tailored analytical frameworks and strategic recommendations.</p>
          </div>
          <div className={styles.workStep}>
            <h3>Implementation & Support</h3>
            <p>Assisting with the deployment of solutions and building internal capabilities.</p>
          </div>
        </div>
        <div className="text-center" style={{ marginTop: '50px' }}>
            <a href="/contact" className="btn-primary">Discuss Your Needs</a>
        </div>
      </section>
    </div>
  );
}

export default ServicesPage;